import axios from 'axios/index'

import createAsyncConst from '../../util/createAsyncConst'
import action, { actionFailed } from '../../util/action'
import config from '../../config'
import { removeEmpty } from '../../util/utils'

export const FETCH_ALERTS = createAsyncConst('FETCH_ALERTS')
export const EDIT_ALERT = createAsyncConst('EDIT_ALERT')
export const SUBMIT_ALERT = createAsyncConst('SUBMIT_ALERT')
export const REMOVE_ALERT = createAsyncConst('REMOVE_ALERT')
export const DISPATCH_ALERT = createAsyncConst('DISPATCH_ALERT')

export function fetchAlerts(filters = {}) {
  return dispatch => {
    dispatch(action(FETCH_ALERTS.ACTION))
    return axios
      .get(`${config.API_URL}/alerts`, { params: removeEmpty(filters) })
      .then(resp => {
        dispatch(action(FETCH_ALERTS.SUCCESS, { data: resp.data, filters }))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_ALERTS, e)))
  }
}

export function edit(id) {
  return dispatch => {
    dispatch(action(EDIT_ALERT.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/alerts/${id}`)
      .then(resp => resp.data.data)
      .then(data => dispatch(action(EDIT_ALERT.SUCCESS, data)))
      .catch(e => dispatch(actionFailed(EDIT_ALERT, e)))
  }
}

export function create(values) {
  return (dispatch, getState) => {
    dispatch(action(SUBMIT_ALERT.ACTION))
    return axios
      .post(`${config.API_URL}/alerts`, values)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_ALERT.SUCCESS, data))
        dispatch(fetchAlerts(getState().alerts.filters))
        return data.data
      })
      .catch(e => dispatch(actionFailed(SUBMIT_ALERT, e)))
  }
}

export function update(values, id) {
  return (dispatch, getState) => {
    dispatch(action(SUBMIT_ALERT.ACTION))
    return axios
      .put(`${config.API_URL}/alerts/${id}`, values)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_ALERT.SUCCESS, data))
        dispatch(fetchAlerts(getState().alerts.filters))
        return data.data
      })
      .catch(e => dispatch(actionFailed(SUBMIT_ALERT, e)))
  }
}

export function remove(id) {
  return (dispatch, getState) => {
    dispatch(action(REMOVE_ALERT.ACTION))
    return axios
      .delete(`${config.API_URL}/alerts/${id}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(REMOVE_ALERT.SUCCESS, data))
        dispatch(fetchAlerts(getState().alerts.filters))
        return true
      })
      .catch(e => dispatch(actionFailed(REMOVE_ALERT, e)))
  }
}

export function dispatchAlert(id) {
  return (dispatch, getState) => {
    dispatch(action(DISPATCH_ALERT.ACTION))
    return axios
      .post(`${config.API_URL}/alerts/${id}/dispatch`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(
          action(DISPATCH_ALERT.SUCCESS, {
            ...data,
            type: data.reached ? 'success' : 'info',
          })
        )
        dispatch(fetchAlerts(getState().alerts.filters))
        return data
      })
      .catch(e => dispatch(actionFailed(DISPATCH_ALERT, e)))
  }
}

export const FETCH_ALERT_RECIPIENTS = createAsyncConst('FETCH_ALERT_RECIPIENTS')

export function fetchRecipients(id, filters = {}) {
  return dispatch => {
    dispatch(action(FETCH_ALERT_RECIPIENTS.ACTION))
    return axios
      .get(`${config.API_URL}/alerts/${id}/recipients`, {
        params: removeEmpty(filters),
      })
      .then(resp => {
        dispatch(action(FETCH_ALERT_RECIPIENTS.SUCCESS))
        return resp.data
      })
      .catch(e => dispatch(actionFailed(FETCH_ALERT_RECIPIENTS, e)))
  }
}
